import Accordion from '@components/Accordion';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';

import OrderItem from './OrderItem';

function Items() {
  const { orderLines } = useCalculatedRequest();
  return (
        <Accordion initialOpen
                   title={
            <Row align='center' spacing={10}>
                <Text size='lg' fontWeight='bold'>
                    주문 상품
                </Text>
                <Text
                      color={colors.gray6}>
                    총 {orderLines.length}건
                </Text>
            </Row> }>
            {orderLines.map((item) => {
              const { shopItemId, defaultOptions, personalOptions } = item;
              const optionIds = [...defaultOptions, ...personalOptions]
                .map((it) => it.options)
                .flat()
                .map((it) => `${it.shopOptionId}${it.quantity}`);
              const key = [shopItemId, ...optionIds].join('-');
              return (
                    <OrderItem item={item}
                               key={key} />
              );
            })}
        </Accordion>
  );
}

export default Items;
